import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { CustomHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    warehouse: WarehouseModel;
}>;

export const DispatchSetPickUpWarehouse: HandlerType = props => {
    props.dispatch({
        type: "Custom/Warehouse/CompletedLoadWarehouse",
        result: props.parameter.warehouse,
    });
};

export const chain = [DispatchSetPickUpWarehouse];

const changeShipWarehouse = createHandlerChainRunner(chain, "ChangeShipWarehouse");
export default changeShipWarehouse;
